import AppNavbar from "@/components/layout/AppNavbar";
import Footer from "@/components/layout/Footer";

import { Col } from "react-bootstrap";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "@/assets/css/style.css";

function Rules() {
  return (
    <>
      <AppNavbar />
      <main className="container-lg nav-padding">
        <Col lg={{ span: 8, offset: 2 }} className="py-5">
          <h2 className="mb-4">Favluv Community Guidelines "Favluv Rules"</h2>
          <p>
            <strong>
              Favluv is a dynamic platform where users can upload, share, and
              manage AI-generated content.
            </strong>
          </p>
          <p>
            Our platform thrives on creativity and connection, allowing you to
            explore, discuss, and collaborate with others who share your
            interests. We encourage you to find—or even create—your creative
            space on Favluv.
          </p>
          <p>
            While not every post or interaction may resonate with you (and some
            content might be unrelatable or even offensive), no space on Favluv
            should be used to harm others. Communities on Favluv should foster
            creativity and a sense of belonging for their members, not diminish
            it. Additionally, everyone on Favluv deserves to feel safe and
            respected, so please uphold the privacy and safety of others.
          </p>
          <p>
            Every community and interaction on Favluv is shaped by its users.
            Some users take on moderator roles to help guide and manage the
            creative spaces, enforcing community rules. The culture of Favluv is
            built explicitly through these rules and implicitly through the
            interactions, feedback, and discussions of our members. Please
            follow the rules of the communities you join and refrain from
            disrupting those where you do not participate.
          </p>
          <p>
            Beyond community rules, platform-wide guidelines apply to all users
            of Favluv. These are enforced by us, the admins, to maintain a safe
            and collaborative environment. Favluv can only thrive if we all
            operate by a shared set of principles. We ask you to adhere not just
            to the letter of these rules but to their spirit.
          </p>

          <h3 className="mt-4 mb-3">Rules</h3>

          <h4 className="mt-3 mb-2">Rule 1: Respect others and foster creativity.</h4>
          <p>
            Favluv is a place to inspire and be inspired, not to attack or
            diminish others. Everyone has the right to use Favluv free of
            harassment, bullying, or threats of harm. Content or interactions
            that promote hate, violence, or discrimination will not be
            tolerated.
          </p>

          <h4 className="mt-3 mb-2">Rule 2: Follow community rules and post authentic content.</h4>
          <p>
            Share AI-generated content you’ve genuinely created or have
            permission to share. Avoid spamming, manipulating content (e.g.,
            vote manipulation or fraud), or disrupting communities.
          </p>

          <h4 className="mt-3 mb-2">Rule 3: Respect privacy.</h4>
          <p>
            Do not harass others or share personal, confidential, or sensitive
            information. Never upload or threaten to upload intimate or explicit
            content of someone without their consent.
          </p>

          <h4 className="mt-3 mb-2">Rule 4: Prohibit harmful or exploitative content.</h4>
          <p>
            Sharing or encouraging any sexual, abusive, or suggestive content
            involving minors is strictly forbidden. Predatory or inappropriate
            behavior toward anyone is also prohibited.
          </p>

          <h4 className="mt-3 mb-2">Rule 5: Avoid impersonation.</h4>
          <p>
            You don’t need to use your real name on Favluv, but don’t
            impersonate others in a misleading or deceptive way.
          </p>

          <h4 className="mt-3 mb-2">Rule 6: Label content appropriately.</h4>
          <p>
            Ensure users have predictable experiences by clearly labeling
            content that is graphic, explicit, or potentially offensive.
          </p>

          <h4 className="mt-3 mb-2">Rule 7: Keep it legal.</h4>
          <p>
            Do not upload illegal content or solicit or facilitate illegal
            activities or transactions.
          </p>

          <h4 className="mt-3 mb-2">Rule 8: Respect the platform.</h4>
          <p>
            Don’t attempt to break the site or interfere with its normal use.
          </p>

          <h3 className="mt-4 mb-3">Enforcement</h3>
          <p>
            We have various ways of enforcing these rules, including (but not
            limited to):
          </p>
          <ul>
            <li>A polite reminder to follow the rules.</li>
            <li>Stronger warnings if the behavior continues.</li>
            <li>Temporary or permanent suspension of accounts.</li>
            <li>Limiting privileges or applying restrictions to accounts.</li>
            <li>Labeling content or placing restrictions on communities.</li>
            <li>Removing harmful content.</li>
            <li>Banning users or communities that violate these principles.</li>
          </ul>
        </Col>
      </main>
      <Footer />
    </>
  );
}

export default Rules;
